import { Icon, Text } from "@gravity-ui/uikit";

import { COLOR, ICON } from "./StatusCard.constants";
import css from "./StatusCard.module.scss";
import { StatusCardProps } from "./StatusCard.types";

export const StatusCard = ({ type, count }: StatusCardProps) => {
  return (
    <div
      className={css.statusCard}
      style={{
        outline: `1px solid var(--g-color-text-${COLOR[type]})`,
        color: `var(--g-color-text-${COLOR[type]})`,
      }}
    >
      <Icon data={ICON[type]} size={24} />
      <Text variant="subheader-2">{count || 0}</Text>
    </div>
  );
};
